import React, { useState, useEffect } from 'react';
import { Progress } from '../ui/progress';
import { Loader2 } from 'lucide-react';

const PROGRESS_MESSAGES = {
  early: [
    "Setting things up...",
    "Getting this ready...",
    "Warming up the engines...",
    "Loading creativity...",
  ],
  mid: [
    "Sprinkling some magic...",
    "Connecting the dots...",
    "Brewing some code...",
    "Working some magic...",
    "Thinking hard...",
  ],
  late: [
    "Tightening the screws...",
    "Polishing the edges...",
    "Almost there...",
    "Fine-tuning the details...",
    "Making it shine...",
  ],
};

const BuildProgressBar = ({ buildProgress }) => {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMsgIndex(prev => prev + 1);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  if (!buildProgress) return null;

  const progress = buildProgress.progress || 0;
  const pool = progress < 40 ? PROGRESS_MESSAGES.early : progress < 75 ? PROGRESS_MESSAGES.mid : PROGRESS_MESSAGES.late;
  const message = pool[msgIndex % pool.length];

  return (
    <div className="px-5 py-3 bg-card border-b border-border" data-testid="build-progress">
      <div className="flex items-center gap-3 mb-2">
        <Loader2 className="w-4 h-4 text-primary animate-spin shrink-0" />
        <span className="text-sm text-foreground/70 font-medium transition-all duration-300" key={`${progress}-${msgIndex}`}>
          {message}
        </span>
      </div>
      <Progress value={progress} className="h-1.5" />
    </div>
  );
};

export default BuildProgressBar;
